var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[("status-badge status-badge--is-" + (_vm.$options.statusAsKebabCase(_vm.props.status, _vm.props.map)) + " " + (_vm.data.staticClass || ''))]},[_vm._v(" "+_vm._s(_vm.$options.labelAsLowerCase(_vm.props.label || _vm.props.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }